import { CloudinaryImage } from '@art-of-hospitality-solutions-llc/ui-kit/components/cloudinary-image';
import { cn } from '@Utils/cn';
import { User } from 'lucide-react';

export interface GuestProfileImageProps {
  /** Cloudinary public ID for CloudinaryImage. Use this when the image is stored in Cloudinary. */
  cloudinaryPublicId?: string | null;
  /** Fallback image URL when not using Cloudinary. */
  imageUrl?: string | null;
  alt?: string;
  className?: string;
}

export function GuestProfileImage({
  cloudinaryPublicId,
  imageUrl,
  alt = 'Guest profile',
  className,
}: GuestProfileImageProps) {
  const containerClass = cn(
    'size-[142px] shrink-0 overflow-hidden rounded-full',
    className,
  );

  if (cloudinaryPublicId) {
    return (
      <div className={containerClass}>
        <CloudinaryImage
          publicId={cloudinaryPublicId}
          className="size-full object-cover"
          alt={alt}
        />
      </div>
    );
  }

  if (imageUrl) {
    return (
      <div className={containerClass}>
        <img src={imageUrl} alt={alt} className="size-full object-cover" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        containerClass,
        'flex items-center justify-center bg-aoh-border font-medium text-aoh-muted dark:bg-zinc-900 dark:text-zinc-400',
      )}
    >
      <User size="72" className="text-aoh-muted dark:text-zinc-600" />
    </div>
  );
}
